import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import enTranslation from './locales/en/translation';
import arTranslation from './locales/ar/translation';
import frTranslation from './locales/fr/translation';

const resources = {
  en: {
    translation: enTranslation
  },
  ar: {
    translation: arTranslation
  },
  fr: {
    translation: frTranslation
  }
};

const SUPPORTED = ['ar', 'en', 'fr'];

// Get saved language from localStorage or default to Arabic
const getSavedLanguage = () => {
  const savedLang = localStorage.getItem('routine-app-language');
  return SUPPORTED.includes(savedLang) ? savedLang : 'ar';
};

// Set initial language
const initialLanguage = getSavedLanguage();

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // French ships partial — any key it's missing falls back to
    // English (then Arabic). EN/AR keep full parity, so this only
    // affects fr.
    fallbackLng: ['en', 'ar'],
    lng: initialLanguage, // Use saved language or default to Arabic
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'routine-app-language',
    },
  });

// Listen for language changes and save to localStorage
i18n.on('languageChanged', (lng) => {
  localStorage.setItem('routine-app-language', lng);
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  // Sync <html lang> with i18n so the browser stops treating the
  // page as a different language. Mobile Chrome / Samsung Internet
  // see lang="en" with Arabic text and offer to "translate" — the
  // resulting butchered text was what users were screenshotting.
  document.documentElement.lang = lng;
});

export default i18n; 